import { H3, H4, Span } from '../../../../../Themes/Components/AbstractElements';
import { formatDate } from '../../../../../utils/formatacoes';
import ConteineresTable from './conteineresTable';
import DadosAduaneiros from './dadosAduaneiros';
import TimelineComponent from './timeline';

const icons = {
  1: <i className='icofont icofont-ship' style={{ fontSize: 32 }} title='Marítima' />,
  4: <i className='icofont icofont-airplane-alt' style={{ fontSize: 32 }} title='Área' />,
};

const ResumoEmbarque = ({ embarque, horizontal = false }) => {
  const colClass = horizontal ? 'col-md-3 col-sm-6 m-b-15' : 'col-sm-12';

  return (
    <div className='row mb-2'>
      <div className={colClass} style={{ display: 'flex', flexDirection: 'column' }}>
        <H4>
          <i className='icofont icofont-location-pin' style={{ fontSize: 16 }} title='Origem' /> ORIGEM
        </H4>
        <Span>País: {embarque?.pais_origem?.nome ?? '-'}</Span>
        <Span>Porto: {embarque?.porto_origem?.nome ?? '-'}</Span>
      </div>
      <div className={horizontal ? colClass : 'col-sm-12 m-t-15'} style={{ display: 'flex', flexDirection: 'column' }}>
        <H4>
          <i className='icofont icofont-location-pin' style={{ fontSize: 16 }} title='Destino' /> DESTINO
        </H4>
        <Span>País: {embarque?.pais_destino?.nome ?? '-'}</Span>
        <Span>Porto: {embarque?.porto_descarga?.nome ?? '-'}</Span>
      </div>
      {!horizontal && (
        <div className='col-sm-12' style={{ display: 'flex', flexDirection: 'column' }}>
          <hr className='m-t-15' />
        </div>
      )}
      <div className={colClass}>
        <H4>
          <i className='icofont icofont-ui-calendar' style={{ fontSize: 16 }} title='ETD' /> ETD
        </H4>
        <Span>{formatDate(embarque?.previsao_partida) ?? '-'}</Span>
      </div>
      <div className={horizontal ? colClass : 'col-sm-12 m-t-15'}>
        <H4>
          <i className='icofont icofont-ui-calendar' style={{ fontSize: 16 }} title='ETA' /> ETA
        </H4>
        <Span>{formatDate(embarque?.previsao_chegada_armador) ?? '-'}</Span>
      </div>
      <div className={horizontal ? colClass : 'col-sm-12 m-t-15'}>
        <H4>
          <i className='icofont icofont-user' style={{ fontSize: 15 }} title='Armador' /> Armador
        </H4>
        <Span>{embarque?.armador?.nome ?? '-'}</Span>
      </div>
      <div className={horizontal ? colClass : 'col-sm-12 m-t-15'}>
        <H4>
          <i className='icofont icofont-ship' style={{ fontSize: 15 }} title='Navios' /> Navios
        </H4>
        <Span>
          {embarque?.embarque_navios &&
            embarque.embarque_navios.map((navio) => (
              <div
                className='col-sm-12'
                key={navio.id}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  color: navio.id === embarque.navio_atual_id ? '#f2ca4c' : '#22BAA0',
                }}
              >
                <Span>{navio.navio.nome}</Span>
                <Span>
                  <i className='icofont icofont-long-arrow-right'></i> Código IMO: {navio.navio.codigo_imo ?? '-'}
                </Span>
                <Span>
                  <i className='icofont icofont-long-arrow-right'></i> Viagem: {navio.viagem ?? '-'}
                </Span>
              </div>
            ))}
          {!embarque?.embarque_navios && <Span>-</Span>}
        </Span>
      </div>
      {!horizontal && (
        <div className='col-sm-12' style={{ display: 'flex', flexDirection: 'column' }}>
          <hr className='m-t-15' />
        </div>
      )}
      <div className={colClass}>
        <H4>
          <i className='icofont icofont-plus-circle' style={{ fontSize: 15 }} title='Data Cadastro' /> Data Cadastro
        </H4>
        <Span>{formatDate(embarque?.data_cadastro) ?? '-'}</Span>
      </div>
      <div className={horizontal ? colClass : 'col-sm-12 m-t-15'}>
        <H4>
          {' '}
          <i className='icofont icofont-refresh' style={{ fontSize: 15 }} title='Última Atualização' /> Última
          Atualização
        </H4>
        <Span>{formatDate(embarque?.ultima_atualizacao) ?? '-'}</Span>
      </div>
    </div>
  );
};

const EmbarqueDetalhes = ({ embarque, origem = 'tracking' }) => {
  const isProcesso = origem === 'processo';

  return (
    <div className='row'>
      <div className={isProcesso ? 'col-xl-12' : 'col-xl-10'}>
        <div className='row'>
          <div className='col-xl-12'>
            <div className='card'>
              <div className='card-body'>
                <div className='row mb-2'>
                  <div className='col-auto'>{icons[embarque?.tipo_embarque_id] ?? '-'}</div>

                  <div className='col-sm'>
                    <H4>Situação</H4>
                    <Span>
                      {embarque?.situacao ? (
                        <span className='badge badge-primary text-wrap text-start'>{embarque?.situacao}</span>
                      ) : (
                        '-'
                      )}
                    </Span>
                  </div>

                  <div className='col-sm text-break'>
                    <h4>{embarque?.tipo_documento}</h4>
                    {isProcesso ? (
                      <a
                        href={`/tracking/embarques/view/${embarque?.id}`}
                        title='Clique para visualizar o embarque.'
                        target='_blank'
                        rel='noopener noreferrer'
                        style={{ marginRight: '5px' }}
                      >
                        {embarque?.numero + (embarque?.numero_house ? ' - ' + embarque.numero_house : '')}{' '}
                        <i className='icofont icofont-external-link' aria-hidden='true'></i>
                      </a>
                    ) : (
                      <span>{embarque?.numero + (embarque?.numero_house ? ' - ' + embarque.numero_house : '')}</span>
                    )}
                  </div>

                  <div className='col-sm-4'>
                    <H4>{embarque?.model === 'Exportacao.Processos' ? 'Exportador' : 'Consignatário'}</H4>
                    <Span>{embarque?.pessoa?.cpfcnpj + ' - ' + embarque?.pessoa?.fantasia ?? '-'}</Span>
                  </div>
                  <div className='col-sm-3'>
                    <H4>Processo(s)</H4>
                    <Span>
                      {embarque?.embarque_processos?.length > 0
                        ? embarque?.embarque_processos.map((embarqueProcesso) => {
                            let processo;
                            let rota;
                            switch (embarque.model) {
                              case 'Exportacao.Processos':
                                processo = embarqueProcesso.exportacao_processo;
                                rota = 'exportacao/processos';
                                break;
                              case 'Importacao.Processos':
                                processo = embarqueProcesso.importacao_processo;
                                rota = 'importacao/processos';
                                break;
                              default:
                                processo = null;
                            }

                            if (processo) {
                              return (
                                <a
                                  key={embarqueProcesso.processo_id}
                                  href={`/${rota}/view/${embarqueProcesso.processo_id}`}
                                  title='Clique para visualizar o processo.'
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  style={{ marginRight: '5px' }}
                                >
                                  {processo.numero} <i className='icofont icofont-external-link' aria-hidden='true'></i>
                                </a>
                              );
                            }

                            return null;
                          })
                        : 'Não há processos vinculados.'}
                    </Span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-xl-12'>
            <div className='card'>
              <div className='card-body'>
                <H3>Linha do tempo</H3>
                <div className='row mb-2'>
                  <TimelineComponent embarque={embarque} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {isProcesso && (
          <div className='row'>
            <div className='col-xl-12'>
              <div className='card'>
                <div className='card-body'>
                  <H3>Dados do embarque</H3>
                  <ResumoEmbarque embarque={embarque} horizontal />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className='row'>
          <div className='col-xl-12'>
            <div className='card'>
              <div className='card-body'>
                <H3>Contêineres</H3>
                <ConteineresTable conteineres={embarque?.embarque_contentores} />
              </div>
            </div>
          </div>
        </div>

        {!isProcesso && (
          <div className='row'>
            <div className='col-xl-12'>
              <div className='card'>
                <div className='card-body'>
                  <DadosAduaneiros embarque={embarque} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {!isProcesso && (
        <div className='col-xl-2'>
          <div className='row'>
            <div className='col-xl-12'>
              <div className='card'>
                <div className='card-body'>
                  <ResumoEmbarque embarque={embarque} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmbarqueDetalhes;
